import { render, staticRenderFns } from "./LaboratoryCategoryEdit.vue?vue&type=template&id=d3cfa5c8"
import script from "./LaboratoryCategoryEdit.vue?vue&type=script&lang=js"
export * from "./LaboratoryCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports